<template>
  <v-app>
    <core-bar @toggle-drawer="toggleDrawer" />

    <core-drawer v-model="drawerVisible" />

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { useDisplay } from 'vuetify';
import coreBar from './components/core/Bar.vue';
import coreDrawer from './components/core/Drawer.vue';

export default {
  name: 'app',

  components: {
    coreBar,
    coreDrawer,
  },
  setup() {
    const { mobile } = useDisplay();

    return { mobile };
  },
  data() {
    return {
      // Open alongside the content on desktop, collapsed behind the nav icon
      // on mobile so the drawer never eats into a small viewport. Vuetify's
      // own resize watcher keeps this in sync when the breakpoint is crossed.
      drawerVisible: !this.mobile,
    };
  },
  methods: {
    toggleDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  /* Keep iOS from inflating text when a phone is rotated to landscape. */
  -webkit-text-size-adjust: 100%;
}
</style>
